import { createModalApproveComponent } from '@utils/modal-util';

/* eslint-disable no-console */
export default {
    install() {
        this.versionCheck();
        setInterval(() => this.versionCheck(), 60 * 1000);
    },
    async versionCheck() {
        if (!import.meta.env.BB_APP_CURRENT_VERSION) {
            return;
        }
        try {
            const response = await fetch('/version?version=' + new Date()
                .getTime());
            if (!response.ok) {
                console.log('version check failed');
                return;
            }
            let version = await response.text();
            version = version.trim();
            if (version !== import.meta.env.BB_APP_CURRENT_VERSION) {
                await createModalApproveComponent(
                    'Neue Version verfügbar',
                    'aktuelle Version: ' + import.meta.env.BB_APP_CURRENT_VERSION + '\nneue Version: ' + version + '\n\nMöchtest du jetzt neu laden?',
                );
                location.reload();
            }
        } catch {
            // ignore version check errors
        }
    },
};
